import { render } from "./ImageTrioShell.vue?vue&type=template&id=b7add78a&scoped=true"
import script from "./ImageTrioShell.vue?vue&type=script&lang=js"
export * from "./ImageTrioShell.vue?vue&type=script&lang=js"

import "./ImageTrioShell.vue?vue&type=style&index=0&id=b7add78a&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7add78a"]])

export default __exports__